import React from "react";
import { CheckboxList } from "../../../components/CheckboxList";

/**
 * Status filter list for the Super Admin Leads inbox.
 *
 * Mirrors the API pattern used by Jobs (`StatusFilterList`):
 * delegates to the shared `CheckboxList` and emits `{ title, value }`
 * with comma-separated canonical status ids that the API understands.
 */
const LEAD_STATUS_OPTIONS = [
  { id: "new", name: "New" },
  { id: "contacted", name: "Contacted" },
  { id: "qualified", name: "Qualified" },
  { id: "demo_scheduled", name: "Demo scheduled" },
  { id: "won", name: "Won" },
  { id: "lost", name: "Lost" },
];

export const LeadsStatusFilterList = (props) => {
  function handleChange(val) {
    if (!val || val.length === 0) {
      props.onChange({
        title: props.value?.defaultText || "",
        value: "",
      });
      return;
    }

    const value = val.map(({ id }) => id).join(",");
    const title =
      val.map(({ name }) => name).join(", ") || props.value?.defaultText;

    if (value) {
      props.onChange({ title, value });
    }
  }

  return (
    <CheckboxList
      onChange={handleChange}
      objectKey="id"
      value={props.value?.value}
      data={LEAD_STATUS_OPTIONS}
    />
  );
};

export default LeadsStatusFilterList;
